import { Link, Outlet, ScrollRestoration, useLocation } from "react-router-dom"
import { useLogout } from "~/auth/use-logout"
import { useViewer } from "~/auth/use-viewer"
import { rootPath, adminUsersPath, adminAdminUsersPath, adminInviteLinksPath } from "~/common/paths"
import gridIcon from "~/images/grid-icon"
import logoutIcon from "~/images/logout-icon"
import postalFunNavLogo from "~/images/postal-fun-nav-logo"
import { cn } from "~/common/cn"
import { UserRole } from "~/__generated__/graphql"

const sidebarItemStyles =
  "flex px-5 py-3 border-b border-gray-300 hover:bg-gray-100 text-sm font-medium text-gray-400 hover:text-gray-900 cursor-pointer"

const SidebarLink = ({ text, to }: { text: string; to: string }) => {
  const location = useLocation()
  const isActive = location.pathname === to

  return (
    <li>
      <Link to={to} className={cn(sidebarItemStyles, isActive && "bg-gray-100 text-gray-900")}>
        <img {...gridIcon} alt="" />
        <div className="pl-4">{text}</div>
      </Link>
    </li>
  )
}

export const SidebarLinks = () => {
  const { viewer } = useViewer()

  return (
    <nav className="mt-5 border-t border-gray-300">
      <ul className="list-none flex-col">
        {viewer.userRole === UserRole.SystemAdmin && (
          <>
            <SidebarLink text={"Users"} to={adminUsersPath({})} />
            <SidebarLink text={"Admin Users"} to={adminAdminUsersPath({})} />
            <SidebarLink text={"Invite Links"} to={adminInviteLinksPath({})} />
          </>
        )}
      </ul>
    </nav>
  )
}

export const SidebarLayout = () => {
  const logout = useLogout()

  return (
    <div className="flex min-h-screen flex-1 grow">
      <div className="sidebar flex w-[200px] flex-col justify-between gap-2 bg-white shadow-md">
        <div>
          <Link to={rootPath({})} className="flex items-center px-5 pt-6">
            <img {...postalFunNavLogo} alt="Postal.Fun" />
          </Link>

          <SidebarLinks />
        </div>
        <div className={cn("border-t border-gray-300", sidebarItemStyles)}>
          <button onClick={logout} className="flex w-full">
            <img {...logoutIcon} alt="" />
            <div className="pl-4">Sign Out</div>
          </button>
        </div>
      </div>

      <div className="flex max-w-full flex-1 flex-col overflow-hidden">
        <Outlet />
        <ScrollRestoration />
      </div>
    </div>
  )
}
